import { render } from "./runningWater.vue?vue&type=template&id=47a33e20&scoped=true"
import script from "./runningWater.vue?vue&type=script&lang=js"
export * from "./runningWater.vue?vue&type=script&lang=js"

import "./runningWater.vue?vue&type=style&index=0&id=47a33e20&lang=scss&scoped=true"

import exportComponent from "D:\\work\\Organizationpersonnel\\organization_personnel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a33e20"]])

export default __exports__